export default {
    
    name: 'presupuestos',
    component: () => import(/* webpackChunkName: "budgets" */ '@/modules/sgcc/layouts/SgccLayout.vue'),
    children: [
        {
            path: '',
            name: 'budgets.home',
            component: () => import(/* webpackChunkName: "budgets-home" */ '@/modules/budgets/layouts/BudgetLayout.vue'),
        },
        {
            path: ':codigo',
            name: 'budgets.simulate',
            component: () => import(/* webpackChunkName: "Period-list" */ '@/modules/budgets/views/Simulate.vue'),
            props: ( route ) => {
                return {
                    codigo: String(route.params.codigo)
                }
            }
        }
    ],

}